import React from "react";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";

import { useStyles } from "./Heading.styles";

const spacers = {
  h1: "20px",
  h2: "24px",
  h3: "24px",
  h4: "20px",
  h5: "16px",
  h6: "12px",
};

const Heading = ({
  variant,
  component,
  color,
  showSpacer,
  children,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Typography
      {...rest}
      variant={variant}
      component={component ?? variant}
      color={color}
      className={classes[variant]}
      sx={{
        marginBottom: showSpacer ? spacers[variant] : "unset",
        ...rest?.sx,
      }}
    >
      {children}
    </Typography>
  );
};

Heading.propTypes = {
  variant: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  component: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  color: PropTypes.oneOf(["text.primary", "text.secondary", "text.tertiary"]),
  showSpacer: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Heading.defaultProps = {
  variant: "h6",
  component: undefined,
  color: "text.primary",
  showSpacer: false,
};

export default Heading;
